import { ApolloQueryResult } from "@apollo/client";
import {
  CompetencyMapGenQuestionsLogQuery,
  CompetencyMapQuery,
  Exact,
  Grade,
  KnowledgeBlockOptionsQuery,
  Scalars,
} from "@generated/graphql";
import { ButtonProps } from "@mui/material";
import { CompetencyMapSelectedParts } from "helpers/competencyMapSelectParts";
import { ReactNode } from "react";

export enum KnowledgeBlockCreationType {
  NEW,
  EXIST,
}

export type KnowledgeBlocksOption = NonNullable<KnowledgeBlockOptionsQuery["knowledgeBlocks"]["data"]>[number];
export type SkillOption = {
  id?: string;
  title: string;
  grades?: Grade[] | null;
  confirmedQuestionsCount?: number | null;
  notConfirmedQuestionsCount?: number | null;
};
export type KnowledgeBlockCompetencyOption = {
  id?: string;
  title?: string;
  skills?: Array<SkillOption> | null;
};
export type CompetencyMapInputs = {
  id?: string;
  title: string;
  specialization: string;
  comment?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createdAt?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updatedAt?: any;
  grades?: string;
  isRepositoryCheck: boolean;
  questionsTime?: string;
  testitngType?: string;
  knowledgeBlocks?: Array<{
    id?: string;
    title?: string;
    knowledgeBlockCompetences?: Array<KnowledgeBlockCompetencyOption> | null;
  }> | null;
};

export type KnowledgeBlockLiteralType = `knowledgeBlocks.${number}`;
export type CompetenciesLiteralType = `${KnowledgeBlockLiteralType}.knowledgeBlockCompetences`;
export type CompetencyLiteralType = `${CompetenciesLiteralType}.${number}`;
export type SkillsLiteralType = `${CompetencyLiteralType}.skills`;
export type SkillLiteralType = `${SkillsLiteralType}.${number}`;

export type RefetchCompetencyMapGenQuestionsLog = (
  variables?:
    | Partial<
        Exact<{
          competencyMapId: Scalars["ID"]["input"];
        }>
      >
    | undefined
) => Promise<ApolloQueryResult<CompetencyMapGenQuestionsLogQuery>>;

export type RefetchCompetencyMap = (
  variables?:
    | Partial<
        Exact<{
          competencyMapId: Scalars["ID"]["input"];
        }>
      >
    | undefined
) => Promise<ApolloQueryResult<CompetencyMapQuery>>;

export type OpenGenerateQuestionsForCMModal = (selectParts?: CompetencyMapSelectedParts) => void;

export type ActionButton = {
  id: string;
  title: ReactNode;
  tooltip?: ReactNode;
  onClick: () => void;
} & Omit<ButtonProps, "onClick">;

export const isKnowledgeBlockCompetencyFieldsNonNullable = (
  knowledgeBlock: KnowledgeBlockCompetencyOption
): knowledgeBlock is NonNullable<KnowledgeBlockOptionsQuery["knowledgeBlocks"]["data"]>[number] => {
  if (knowledgeBlock?.id && knowledgeBlock?.title) return true;
  return false;
};

export const isSkillFieldsNonNullable = (skill: SkillOption): skill is Required<SkillOption> => {
  if (skill?.id && skill?.title) return true;
  return false;
};
